const AW_BASE = "/aw/";
const AW_TITLE = "Amazon.de Help & Customer Service";

let digiRoot = null;

export function setDigiRoot(root) {
  digiRoot = root;
}

function setHeadLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

// Replaces the DIGI app with the AW build in place, keeping the current URL.
async function loadAw() {
  const res = await fetch(AW_BASE + "asset-manifest.json", { cache: "no-cache" });
  if (!res.ok) throw new Error("AW build not found at " + AW_BASE);
  const { entrypoints = [] } = await res.json();

  if (digiRoot) {
    digiRoot.unmount();
    digiRoot = null;
  }
  document
    .querySelectorAll('link[rel="stylesheet"], style')
    .forEach((el) => el.remove());

  document.title = AW_TITLE;
  setHeadLink("icon", AW_BASE + "favicon.webp");
  setHeadLink("apple-touch-icon", AW_BASE + "favicon.webp");
  document.body.removeAttribute("style");
  window.scrollTo(0, 0);

  entrypoints.forEach((file) => {
    const url = AW_BASE + file;
    if (file.endsWith(".css")) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = url;
      document.head.appendChild(link);
    } else if (file.endsWith(".js")) {
      const script = document.createElement("script");
      script.src = url;
      script.defer = true;
      document.body.appendChild(script);
    }
  });
}

export async function switchToAw() {
  try {
    await loadAw();
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}
